import ModalShell from './ModalShell.jsx';
import { labels } from '../data/i18n.js';
import { useLanguage } from '../hooks/useLanguage.jsx';
import { useRef } from 'react';
import { useKeyControls } from '../hooks/useKeyControls.js';
import Header from './Header.jsx';

export default function LightboxModal({
  isOpen,
  activeIndex,
  artworks,
  onClose,
  onPrev,
  onNext,
}) {
  const { t } = useLanguage();
  const artwork = artworks[activeIndex];
  const touchStartX = useRef(null);
  const touchStartY = useRef(null);

  useKeyControls({ isOpen, onClose, onPrev, onNext });

  if (!isOpen || !artwork) return null;

  return (
    <ModalShell isOpen={isOpen} onClose={onClose} className="lightbox">
      <div className="lightbox-header-area">
        <Header forceIsBio onNavClick={onClose} hideLogo />
      </div>
      <div
        className="lightbox-stage"
        onTouchStart={(event) => {
          const touch = event.touches[0];
          touchStartX.current = touch.clientX;
          touchStartY.current = touch.clientY;
        }}
        onTouchEnd={(event) => {
          if (touchStartX.current === null || touchStartY.current === null) return;
          const touch = event.changedTouches[0];
          const deltaX = touch.clientX - touchStartX.current;
          const deltaY = touch.clientY - touchStartY.current;
          const absX = Math.abs(deltaX);
          const absY = Math.abs(deltaY);
          touchStartX.current = null;
          touchStartY.current = null;
          if (absX < 40 || absX < absY) return;
          if (deltaX < 0) {
            onNext();
          } else {
            onPrev();
          }
        }}
      >
        <button
          type="button"
          className="lightbox-side lightbox-prev"
          onClick={onPrev}
          aria-label={t(labels.prev)}
        >
          <svg
            className="lightbox-arrow"
            width="100"
            height="100"
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M62.5 75L37.5 50L62.5 25"
              stroke="currentColor"
              strokeWidth="1.125"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <figure className="lightbox-figure">
          <img src={artwork.images.full} alt={t(artwork.alt) || t(artwork.title)} />
          <figcaption>
            <h2>{t(artwork.title)}</h2>
            <p>{t(artwork.material)} - {artwork.height} - {artwork.year}</p>
          </figcaption>
        </figure>
        <button
          type="button"
          className="lightbox-side lightbox-next"
          onClick={onNext}
          aria-label={t(labels.next)}
        >
          <svg
            className="lightbox-arrow lightbox-arrow--next"
            width="100"
            height="100"
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M62.5 75L37.5 50L62.5 25"
              stroke="currentColor"
              strokeWidth="1.125"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </ModalShell>
  );
}
